module.exports = __webpack_public_path__ + "static/media/meteringicon02@2x.14e81452.png";